import type { BookingPreference, EditPreferencesFormValue } from './types'
import isEqual from 'lodash/isEqual'
import { PREFERENCE_CUSTOMER_INPUT_MAX_LENGTH } from '@/scopes/common/domain/policies/bookingPreference'

const PREFERENCES_FITTING_WITHOUT_SEARCH = 6

export function isCustomerInputMissing(preference: EditPreferencesFormValue): boolean {
  return preference.isSelected && preference.customerInput.trim() === ''
}

export function isCustomerInputTooLong(preference: EditPreferencesFormValue): boolean {
  return preference.isSelected && preference.customerInput.length > PREFERENCE_CUSTOMER_INPUT_MAX_LENGTH
}

function getSelectionToSave(preferences: EditPreferencesFormValue[]) {
  return preferences
    .filter(preference => preference.isSelected)
    .map(preference => ({ id: preference.id, customerInput: preference.customerInput.trim() }))
}

export function hasPreferencesSelectionChanged(
  savedPreferences: EditPreferencesFormValue[],
  editedPreferences: EditPreferencesFormValue[],
): boolean {
  return !isEqual(getSelectionToSave(savedPreferences), getSelectionToSave(editedPreferences))
}

export function isPreferencesSearchNeeded(preferencesCount: number): boolean {
  return preferencesCount > PREFERENCES_FITTING_WITHOUT_SEARCH
}

export function isPreferencesSearchWithoutResults(preferencesCount: number, visiblePreferencesCount: number): boolean {
  return preferencesCount > 0 && visiblePreferencesCount === 0
}

export function filterPreferencesBySearch(preferences: BookingPreference[], searchTerm: string): BookingPreference[] {
  const search = searchTerm.trim().toLowerCase()

  return preferences.filter(preference => preference.text.toLowerCase().includes(search))
}

export function sortPreferencesBySelection(preferences: BookingPreference[]): BookingPreference[] {
  return [...preferences].sort((a, b) => Number(b.isSelected) - Number(a.isSelected))
}

export function sortPreferencesLike(
  preferences: BookingPreference[],
  order: BookingPreference[],
): BookingPreference[] {
  const positionById = new Map(order.map(({ id }, index) => [id, index]))

  return [...preferences].sort(
    (a, b) => (positionById.get(a.id) ?? order.length) - (positionById.get(b.id) ?? order.length),
  )
}
